import React, { Component } from "react";
import MenuCategoriasPrograma from "./MenuCategoriasPrograma";

class MenuCategorias extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.productoActual == "notfound")
            return null;

        let categoriaActual = this.props.categoriaActual || "";
        let { categorias } = this.props;

        return (
            <div className="navbar navbar-static-top menu-program" role="navigation" >
                <div className="container">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                    </div>
                    <div className="collapse navbar-collapse">
                        <MenuCategoriasPrograma
                            categorias={categorias}
                            productoActual={this.props.productoActual}
                            categoriaActual={categoriaActual}
                        />
                    </div>
                </div>
                {this.props.children}
            </div>
        );
    }
}

export default MenuCategorias;


// WEBPACK FOOTER //
// ./Portico/App/Screens/MenuCategorias/components/MenuCategorias.jsx